import React from 'react'
import PropTypes from 'prop-types'

import renderNode from './Utilities/NodeRenderer'
import ListRenderer from './Utilities/ListRenderer'

function RichTextBlock({ data, typeOfContent }) {
  function determineFont(item) {
    return `__${item.nodeType}`
  }

  function determineId(item) {
    let id = null
    if (item.nodeType.includes('heading')) {
      id = encodeURIComponent(
        `${item.content[0].value.toLowerCase().split(' ').join('-').replace(/\n/g, '')}` // remove new line from beginning of string
      )
    }
    // fixes issue with '-' being appended to the end of the id string
    if (id?.endsWith('-')) {
      id = id.slice(0, -1)
    }
    return id
  }

  function anchorsLinks(array) {
    const links = array.map((item, index) => {
      const i = index
      const hrefName = encodeURIComponent(`${item.toLowerCase().split(' ').join('-')}`)

      return (
        <div className="rich-text-block rich-text-block__contents" key={i}>
          <a href={`#${hrefName}`}>{item}</a>
        </div>
      )
    })
    return links
  }

  function checkColums(number, index) {
    if (number === 3) {
      return 'three-col'
    }
    if (number === 4 && index === 0) {
      return 'four-col-lg'
    }

    if (number === 4) {
      return 'four-col-sm'
    }
    return ''
  }

  function tableCreator(tables) {
    if (tables?.length > 1) {
      const tablesGroup = tables.map(item => {
        return (
          <table className="privacy-notice__table" border="1" key={item}>
            <tbody>
              {item.tableData.tableData.map((row, index) => {
                if (index === 0) {
                  return (
                    <tr key={item.id}>
                      {row.map((sentence, i) => {
                        return (
                          <th
                            scope="col"
                            className="privacy-notice__header"
                            type={checkColums(row.length, i)}
                            key={sentence}
                            span="col"
                          >
                            {sentence}
                          </th>
                        )
                      })}
                    </tr>
                  )
                }

                return (
                  <tr className="privacy-notice__row" key={row}>
                    {row.map(sentence => {
                      return (
                        <td className="privacy-notice__data" key={sentence}>
                          {sentence}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        )
      })
      return tablesGroup
    }
    return (
      <table className="privacy-notice__table" border="1">
        <tbody>
          {tables?.tableData?.tableData.map((row, index) => {
            if (index === 0) {
              return (
                <tr key={row.id}>
                  {row.map((sentence, i) => {
                    return (
                      <th
                        scope="col"
                        className="privacy-notice__header"
                        type={checkColums(row.length, i)}
                        key={sentence}
                      >
                        {sentence}
                      </th>
                    )
                  })}
                </tr>
              )
            }

            return (
              <tr className="privacy-notice__row" key={row}>
                {row.map(sentence => {
                  return (
                    <td className="privacy-notice__data" key={sentence}>
                      {sentence}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  return (
    <section className={typeOfContent === 'legal' ? 'legal' : ''}>
      <div className="rich-text-block__container container__inner">
        <h1 className={data.contents ? 'rich-text-block rich-text-block__heading-3' : ''}>
          {data.contentsTitle && data.contentsTitle}
        </h1>
        {typeOfContent !== 'legal' && data.contents ? anchorsLinks(data.contents) : ''}
        <hr
          className={
            data.contents && typeOfContent !== 'legal'
              ? 'rich-text-block rich-text-block__divider'
              : 'no-display'
          }
        />
        {data?.paragraph?.raw
          ? JSON.parse(data?.paragraph?.raw)?.content?.map((item, index) => {
              const i = index

              const paragraph = renderNode({ typeOfContent, data: item.content })

              const strongTitle = paragraph.every(arrayValue => typeof arrayValue !== 'string')

              const setClassName = () => {
                if (data.richTextTitle === 'Accessibility' && item.nodeType === 'heading-2') {
                  return 'legal__heading heading-form legal__title'
                }
                if (data.richTextTitle === 'Accessibility' && strongTitle) {
                  return 'general-text rich-text-block'
                }
                if (data.richTextTitle === 'Privacy Policy' && item.nodeType === 'heading-3') {
                  return 'legal__heading--sub legal__title'
                }

                if (data.richTextTitle === 'Privacy' && item.nodeType === 'heading-3') {
                  return 'general-text__sub legal__title'
                }
                if (
                  data.richTextTitle === 'Privacy Policy' &&
                  item.nodeType === 'heading-2' &&
                  i !== 0
                ) {
                  return 'legal__title legal__heading heading-form'
                }

                if (typeOfContent === 'legal' && item.nodeType === 'heading-2') {
                  return 'legal__heading heading-form'
                }

                return `general-text rich-text-block rich-text-block${determineFont(item)}`
              }

              if (item.nodeType === 'unordered-list') {
                return (
                  <ListRenderer
                    key={data.id}
                    item={item}
                    data={data}
                    typeOfContent={typeOfContent}
                  />
                )
              }

              if (item.nodeType === 'ordered-list') {
                return (
                  <ListRenderer
                    key={data.id}
                    item={item}
                    data={data}
                    typeOfContent={typeOfContent}
                  />
                )
              }
              const setParagraphType = text => {
                if (text.includes('<links>')) {
                  return anchorsLinks(data.contents)
                }

                if (typeof text[0] === 'string' && text[0].includes('<table')) {
                  const txt = text[0]
                  let numb = txt.match(/\d/g)
                  numb = numb.join('') - 1
                  return tableCreator(data?.tableData?.[numb])
                }

                if (data.richTextTitle === 'Privacy Policy' && text.includes('<Manage Settings>')) {
                  return (
                    <button
                      className="segment-manage-settings-link"
                      type="button"
                      onClick={() => {
                        window.consentManager.openConsentManager()
                      }}
                    >
                      Manage Settings
                    </button>
                  )
                }
                return text
              }

              return (
                <p id={determineId(item)} className={setClassName()} key={i}>
                  {setParagraphType(paragraph)}
                </p>
              )
            })
          : null}
      </div>
    </section>
  )
}

RichTextBlock.defaultProps = {
  typeOfContent: ''
}
RichTextBlock.propTypes = {
  data: PropTypes.object.isRequired,
  typeOfContent: PropTypes.string
}
export default RichTextBlock
